var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 4.49935V3.83268C12.3333 2.89926 12.3333 2.43255 12.1517 2.07603C11.9919 1.76243 11.7369 1.50746 11.4233 1.34767C11.0668 1.16602 10.6001 1.16602 9.66667 1.16602H8.33333C7.39991 1.16602 6.9332 1.16602 6.57668 1.34767C6.26308 1.50746 6.00811 1.76243 5.84832 2.07603C5.66667 2.43255 5.66667 2.89926 5.66667 3.83268V4.49935M7.33333 9.08268V13.2493M10.6667 9.08268V13.2493M1.5 4.49935H16.5M14.8333 4.49935V13.8327C14.8333 15.2328 14.8333 15.9329 14.5608 16.4677C14.3212 16.9381 13.9387 17.3205 13.4683 17.5602C12.9335 17.8327 12.2335 17.8327 10.8333 17.8327H7.16667C5.76654 17.8327 5.06647 17.8327 4.53169 17.5602C4.06129 17.3205 3.67883 16.9381 3.43915 16.4677C3.16667 15.9329 3.16667 15.2328 3.16667 13.8327V4.49935",
    stroke: "#CC1440",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3c5d900121ea5c390c4e811a01ad5ecb.svg";
export { ForwardRef as ReactComponent };